import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';
import { backerConsumerBackerActivityKeys } from './activity/keys';
import { backerConsumerBackerIntentKeys } from './intent/keys';
import { backerConsumerBackerSubscriptionsKeys } from './subscriptions/keys';

// This name isn't confusing at all.
const backerConsumerBackerKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'backer'] as const;
  return createQueryKey({
    all: [...key] as const,
    detail: [...key, 'detail'] as const,
    intent: backerConsumerBackerIntentKeys(key),
    activity: backerConsumerBackerActivityKeys(key),
    subscriptions: backerConsumerBackerSubscriptionsKeys(key),
  });
};

export { backerConsumerBackerKeys };
